import React, { useEffect, useState } from "react";
import { Box, Button, Grid, IconButton } from "@mui/material";
import { FeTextField, FeAutocomplete } from "../../../FormElements";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";

import Checkbox from "@mui/material/Checkbox";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import { updateObjectValue } from "../../../../utils/helper";
import FeDesktopDatePicker from "../../../FormElements/FeDesktopDatePicker";
import dayjs from "dayjs";
import doctorAPI from "../../../../utils/doctorAPI";
import { isEmpty } from "lodash";
const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const RadioTherapyForm = ({ onStateChange, editedObj, updatedObj }) => {
  const [obj, setObj] = useState({
    radiotherapy_schedules: [
      {
        start_date: null,
        end_date: null,
        intent: "",
        modalities: [],
        sites: [],
        fraction: null,
        fraction_number: null,
        total_dose: null,
      },
    ],
  });

  const [radioList, setRadioList] = useState([]);
  const [metList, setMetList] = useState([]);

  useEffect(() => {
    getRadioList();
    getMetGroupList();

    return () => {};
  }, []);
  const getMetGroupList = async () => {
    const { data } = await doctorAPI.get(
      "doctor/diagnosis-metastatic-site-records-all"
    );
    setMetList(data.data);
  };
  const getRadioList = async () => {
    const { data } = await doctorAPI.get(
      "doctor/radiotherapy-schedule-records-all"
    );
    setRadioList(data.data);
  };
  useEffect(() => {
    let u = null,
      e = null;
    if (updatedObj) {
      u = updateObjectValue(obj, updatedObj);
    }
    if (editedObj) {
      e = updateObjectValue(obj, editedObj);
    }

    if (u) {
      setTimeout(() => {
        setObj(u);
      }, 100);
      return;
    } else if (!u && e) {
      if (e.radiotherapy_schedules.length === 0) {
        setObj({
          radiotherapy_schedules: [
            {
              start_date: null,
              end_date: null,
              intent: "",
              modalities: [],
              sites: [],
              fraction: null,
              fraction_number: null,
              total_dose: null,
            },
          ],
        });
        return;
      }

      console.log("e radio", e.radiotherapy_schedules);
      if (e.radiotherapy_schedules.length > 0) {
        const radiotherapy_schedules = e.radiotherapy_schedules.map(
          (item, i) => {
            let obj = {
              start_date: item.start_date,
              end_date: item.end_date,
              intent: item.intent,
              modalities: [],
              sites: [],
              fraction: item.fraction,
              fraction_number: item.fraction_number,
              total_dose: item.total_dose,
            };
            if (item?.radiotherapy_schedule_modalities?.length > 0) {
              obj.modalities = item.radiotherapy_schedule_modalities.map(
                (innerItem, k) => {
                  let innerObj = {
                    value: innerItem.value,
                  };
                  return innerObj;
                }
              );
            }
            if (item?.radiotherapy_schedule_sites?.length > 0) {
              obj.sites = item.radiotherapy_schedule_sites.map(
                (innerItem, k) => {
                  let innerObj = {
                    value: innerItem.value,
                  };
                  return innerObj;
                }
              );
            }
            return obj;
          }
        );
        if (radiotherapy_schedules && radiotherapy_schedules.length > 0) {
          setTimeout(() => {
            setObj({
              radiotherapy_schedules,
            });
          }, 100);
        }
      }
    }
  }, [updatedObj, editedObj]);

  useEffect(() => {
    if (!isEmpty(obj)) onStateChange(obj);
  }, [obj]);

  const addDiagnosisField = () => {
    setObj({
      ...obj,
      radiotherapy_schedules: [
        ...obj.radiotherapy_schedules,
        {
          start_date: null,
          end_date: null,
          intent: "",
          modalities: [],
          sites: [],
          fraction: null,
          fraction_number: null,
          total_dose: null,
        },
      ],
    });
  };
  const removeDiagnosisFields = (index) => {
    const rows = [...obj.radiotherapy_schedules];
    rows.splice(index, 1);
    setObj({ ...obj, radiotherapy_schedules: rows });
  };
  const handleChangeDiagnosis = (index, name, value) => {
    const list = [...obj.radiotherapy_schedules];
    list[index][name] = value;
    setObj({ ...obj, radiotherapy_schedules: list });
  };

  useEffect(() => {
    if (!isEmpty(obj)) onStateChange(obj);
  }, [obj]);

  function isNumeric(num) {
    return !isNaN(num);
  }
  return (
    <>
      {" "}
      <Grid item xs={12} sm={12}>
        <Grid container spacing={1}>
          <Grid mb={1} item sm={4}>
            Radiotherapy Schedules
          </Grid>
        </Grid>
        {obj.radiotherapy_schedules.map((data, index) => {
          const {
            start_date,
            end_date,
            intent,
            modalities,
            sites,
            fraction,
            fraction_number,
            total_dose,
          } = data;

          return (
            <Grid container spacing={2} key={index} mb={2}>
              <Grid item xs={3} md={3}>
                <FeAutocomplete
                  multiple
                  disableCloseOnSelect
                  //  disabled={editedObj}
                  value={sites.map((o) => o.value)}
                  onChange={(e, v) => {
                    handleChangeDiagnosis(
                      index,
                      "sites",
                      v.map((o) => {
                        return { value: o };
                      })
                    );
                  }}
                  renderOption={(props, option, { selected }) => {
                    return (
                      <li {...props}>
                        <Checkbox
                          icon={icon}
                          //  disabled={editedObj}
                          checkedIcon={checkedIcon}
                          style={{ marginRight: 8 }}
                          checked={selected}
                        />
                        {option}
                      </li>
                    );
                  }}
                  options={
                    metList.length > 0
                      ? [...new Set(metList.map((o) => o.name))]
                      : []
                  }
                  id="Radiotherapy Site"
                  label="Radiotherapy Site"
                />
              </Grid>
              <Grid item xs={3} md={3}>
                <Box>
                  <FeDesktopDatePicker
                    label="Start Date"
                    inputFormat="DD/MM/YYYY"
                    name="start_date"
                    value={start_date}
                    //  disabled={editedObj}
                    onChange={(val) => {
                      handleChangeDiagnosis(
                        index,
                        "start_date",
                        dayjs(val).format("YYYY-MM-DD")
                      );
                    }}
                  />
                </Box>
              </Grid>
              <Grid item xs={2} md={2}>
                <FeDesktopDatePicker
                  label="End Date"
                  inputFormat="DD/MM/YYYY"
                  name="end_date"
                  value={end_date}
                  //  disabled={editedObj}
                  onChange={(val) => {
                    handleChangeDiagnosis(
                      index,
                      "end_date",
                      dayjs(val).format("YYYY-MM-DD")
                    );
                  }}
                />
              </Grid>
              <Grid item xs={3} md={3}>
                <FeAutocomplete
                  value={intent}
                  onChange={(e, v) => {
                    if (!v) {
                      handleChangeDiagnosis(index, "intent", v);
                      return;
                    }

                    handleChangeDiagnosis(index, "intent", v);
                  }}
                  label={"Intent"}
                  options={
                    radioList.length > 0 &&
                    radioList.filter((o) => o.type === "Intent").length > 0
                      ? [
                          ...new Set(
                            radioList
                              .filter((o) => o.type === "Intent")
                              .map((o) => o.value)
                          ),
                        ]
                      : []
                  }
                  id="Histopathology"
                />
              </Grid>

              <Grid item xs={3} md={3}>
                <FeAutocomplete
                  multiple
                  disableCloseOnSelect
                  //  disabled={editedObj}
                  value={modalities.map((o) => o.value)}
                  onChange={(e, v) => {
                    handleChangeDiagnosis(
                      index,
                      "modalities",
                      v.map((o) => {
                        return { value: o };
                      })
                    );
                  }}
                  renderOption={(props, option, { selected }) => {
                    return (
                      <li {...props}>
                        <Checkbox
                          icon={icon}
                          //  disabled={editedObj}
                          checkedIcon={checkedIcon}
                          style={{ marginRight: 8 }}
                          checked={selected}
                        />
                        {option}
                      </li>
                    );
                  }}
                  options={
                    radioList.length > 0 &&
                    radioList.filter((o) => o.type === "Modality").length > 0
                      ? [
                          ...new Set(
                            radioList
                              .filter((o) => o.type === "Modality")
                              .map((o) => o.value)
                          ),
                        ]
                      : []
                  }
                  id="Radiotherapy Schedule Modality"
                  label="Radiotherapy Schedule Modality"
                />
              </Grid>
              <Grid item xs={2} md={2}>
                <FeTextField
                  type="number"
                  value={fraction}
                  onChange={(e) => {
                    const v = e.target.value;
                    if (!v) {
                      handleChangeDiagnosis(index, "fraction", v);
                      handleChangeDiagnosis(index, "total_dose", v);
                      return;
                    }

                    handleChangeDiagnosis(index, "fraction", v);
                    if (
                      !isEmpty(fraction_number) &&
                      isNumeric(v) &&
                      isNumeric(fraction_number)
                    ) {
                      handleChangeDiagnosis(
                        index,
                        "total_dose",
                        v * fraction_number
                      );
                    } else {
                      handleChangeDiagnosis(index, "total_dose", null);
                    }
                    // if (isNumeric(v) && !isNumeric(fraction_number)) {
                    //   handleChangeDiagnosis(index, "total_dose", v);
                    // }
                    // if (!isNumeric(v) && isNumeric(fraction_number)) {
                    //   handleChangeDiagnosis(
                    //     index,
                    //     "total_dose",
                    //     fraction_number
                    //   );
                    // }
                    // if (!isNumeric(v) && !isNumeric(fraction_number)) {
                    //   handleChangeDiagnosis(index, "total_dose", 0);
                    // }
                  }}
                  label={"Fraction Dose"}
                />
                {/* <FeAutocomplete
                  value={fraction}
                  onChange={(e, v) => {
                    if (!v) {
                      handleChangeDiagnosis(index, "fraction", v);
                      handleChangeDiagnosis(index, "total_dose", v);
                      return;
                    }

                    handleChangeDiagnosis(index, "fraction", v);
                    if (
                      !isEmpty(fraction_number) &&
                      isNumeric(v) &&
                      isNumeric(fraction_number)
                    ) {
                      handleChangeDiagnosis(
                        index,
                        "total_dose",
                        v * fraction_number
                      );
                    } else {
                      handleChangeDiagnosis(index, "total_dose", null);
                    }
                    // if (isNumeric(v) && !isNumeric(fraction_number)) {
                    //   handleChangeDiagnosis(index, "total_dose", v);
                    // }
                    // if (!isNumeric(v) && isNumeric(fraction_number)) {
                    //   handleChangeDiagnosis(
                    //     index,
                    //     "total_dose",
                    //     fraction_number
                    //   );
                    // }
                    // if (!isNumeric(v) && !isNumeric(fraction_number)) {
                    //   handleChangeDiagnosis(index, "total_dose", 0);
                    // }
                  }}
                  label={"Fraction Dose"}
                  options={
                    radioList.length > 0 &&
                    radioList.filter((o) => o.type === "Fraction").length > 0
                      ? [
                          ...new Set(
                            radioList
                              .filter((o) => o.type === "Fraction")
                              .map((o) => o.value)
                          ),
                        ]
                      : []
                  }
                  id="Histopathology"
                /> */}
              </Grid>
              <Grid item xs={2} md={2}>
                <FeTextField
                  type="number"
                  value={fraction_number}
                  onChange={(e) => {
                    const v = e.target.value;
                    if (!v) {
                      handleChangeDiagnosis(index, "fraction_number", v);
                      handleChangeDiagnosis(index, "total_dose", v);

                      return;
                    }

                    handleChangeDiagnosis(index, "fraction_number", v);
                    if (
                      !isEmpty(fraction) &&
                      isNumeric(v) &&
                      isNumeric(fraction)
                    ) {
                      handleChangeDiagnosis(index, "total_dose", v * fraction);
                    } else {
                      handleChangeDiagnosis(index, "total_dose", null);
                    }
                  }}
                  label={"Fraction number / Dose"}
                />
                {/* <FeAutocomplete
                  value={fraction_number}
                  onChange={(e, v) => {
                    if (!v) {
                      handleChangeDiagnosis(index, "fraction_number", v);
                      handleChangeDiagnosis(index, "total_dose", v);

                      return;
                    }

                    handleChangeDiagnosis(index, "fraction_number", v);
                    if (
                      !isEmpty(fraction) &&
                      isNumeric(v) &&
                      isNumeric(fraction)
                    ) {
                      handleChangeDiagnosis(index, "total_dose", v * fraction);
                    } else {
                      handleChangeDiagnosis(index, "total_dose", null);
                    }
                    // if (isNumeric(v) && !isNumeric(fraction)) {
                    //   handleChangeDiagnosis(index, "total_dose", v);
                    // }
                    // if (!isNumeric(v) && isNumeric(fraction)) {
                    //   handleChangeDiagnosis(index, "total_dose", fraction);
                    // }
                    // if (!isNumeric(v) && !isNumeric(fraction)) {
                    //   handleChangeDiagnosis(index, "total_dose", 0);
                    // }
                  }}
                  label={"Fraction number / Dose"}
                  options={
                    radioList.length > 0 &&
                    radioList.filter((o) => o.type === "Fraction Number")
                      .length > 0
                      ? [
                          ...new Set(
                            radioList
                              .filter((o) => o.type === "Fraction Number")
                              .map((o) => o.value)
                          ),
                        ]
                      : []
                  }
                  id="Histopathology"
                /> */}
              </Grid>

              <Grid item xs={2} md={2}>
                <FeTextField
                  key={total_dose}
                  label="Total Dose in cGy"
                  name="total_dose"
                  value={total_dose ?? null}
                  //  disabled={editedObj}
                  // onChange={(e) => {
                  //   handleChangeDiagnosis(index, "total_dose", e.target.value);
                  // }}
                />
              </Grid>

              <Grid item xs={1}>
                {obj.radiotherapy_schedules.length !== 1 && (
                  <IconButton
                    aria-label="delete"
                    size="large"
                    color="error"
                    //  disabled={editedObj}
                    onClick={() => removeDiagnosisFields(index)}
                  >
                    <DeleteForeverIcon fontSize="inherit" />
                  </IconButton>
                )}
              </Grid>
            </Grid>
          );
        })}
        <Grid item xs={12}>
          <Button
            variant="outlined"
            color="success"
            //  disabled={editedObj}
            onClick={addDiagnosisField}
          >
            Add New
          </Button>
        </Grid>
      </Grid>
      <Grid item xs={6} md={6}></Grid>
    </>
  );
};

export default RadioTherapyForm;
